const { createAction } = require('../../helpers')
const {
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_RESET,
  GET_PROFILE_ERROR,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_RESET,
  UPDATE_PROFILE_ERROR,
} = require('./constants')

/**
 * @param {Array<string>} iatas
 * @return {Promise<*>}
 */
const profile = () => createAction(GET_PROFILE)

const profileSuccess = prof => createAction(GET_PROFILE_SUCCESS, { profile: prof })

const profileError = error => createAction(GET_PROFILE_ERROR, { error })

const profileReset = () => createAction(GET_PROFILE_RESET)

const updateProfile = ({userId, fullname, username, email, phone}) => createAction(UPDATE_PROFILE, {
  userId, fullname, username, email, phone,
})

const updateProfileSuccess = prof => createAction(UPDATE_PROFILE_SUCCESS, { profile: prof })

const updateProfileError = error => createAction(UPDATE_PROFILE_ERROR, { error })

const updateProfileReset = () => createAction(UPDATE_PROFILE_RESET)

module.exports = {
  profile,
  profileSuccess,
  profileError,
  profileReset,

  updateProfile,
  updateProfileSuccess,
  updateProfileError,
  updateProfileReset,
}
